import { Injectable } from '@angular/core';
import { BehaviorSubject, tap } from 'rxjs';
import { FilterResource } from '../resource/filter.resource';
import { FilterDto } from '@maporium-workspace/shared';
import { MapService } from './map.service';

@Injectable({ providedIn: 'root' })
export class FilterService {
  public activeFiltersSubject: BehaviorSubject<FilterDto[]> = new BehaviorSubject<FilterDto[]>([]);
  public filtersChangedSubject: BehaviorSubject<void> = new BehaviorSubject<void>(undefined);

  constructor(
    private resource: FilterResource,
    private mapService: MapService
  ) {}

  public getAll(mapId: string) {
    return this.resource.getAll(mapId);
  }

  public getAllGlobal() {
    return this.resource.getAllGlobal();
  }

  public getOne(id: string) {
    return this.resource.getOne(id);
  }

  public save(filter: Partial<FilterDto>) {
    return this.resource.create(filter).pipe(
      tap(() => this.filtersChangedSubject.next())
    );
  }

  public update(id: string, filter: Partial<FilterDto>) {
    return this.resource.update(id, filter).pipe(
      tap(() => this.filtersChangedSubject.next())
    );
  }

  public delete(filterId: string) {
    return this.resource.delete(filterId).pipe(
      tap(() => this.filtersChangedSubject.next())
    );
  }

  public toggleFilter(filter: FilterDto) {
    const currentActiveFilters = this.activeFiltersSubject.value;
    const isActive = currentActiveFilters.some(f => f.id === filter.id);

    if (isActive) {
      const updatedFilters = currentActiveFilters.filter(f => f.id !== filter.id);
      this.activeFiltersSubject.next(updatedFilters);
    } else {
      this.activeFiltersSubject.next([...currentActiveFilters, filter]);
    }
  }

  public isFilterActive(filterId: string): boolean {
    return this.activeFiltersSubject.value.some(f => f.id === filterId);
  }

  public getActiveFilters(): FilterDto[] {
    return this.activeFiltersSubject.value;
  }

  public clearActiveFilters() {
    this.activeFiltersSubject.next([]);
  }
}